import { useParams } from "react-router";
import { useMemo } from "react";
import articlesListData from "./articlesListData";
import { Player } from "video-react";
import "video-react/dist/video-react.css";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  MenuList,
  Paper,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { Navigate, Link as RouterLink } from "react-router-dom";
import { typographyClasses } from "@mui/material/Typography";
import { blue } from "@mui/material/colors";
import { useTranslation } from "react-i18next";

const ArticleView = () => {
  const { t: _t, i18n } = useTranslation();
  let { articleUrl } = useParams();

  const articlesList = useMemo(() => articlesListData.filter((el) => el.language === i18n.resolvedLanguage), [i18n.resolvedLanguage]);

  const data = useMemo(() => {
    return articlesListData.find((el) => el.url === articleUrl);
  }, [articleUrl]);

  if (!data) {
    return <Navigate to={"/articles"} />;
  }

  return (
    <div className="article-preview-page">
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Card>
            <CardContent>
              <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                <Typography variant="h4">{data.title}</Typography>
                <Typography component="div">{data.date}</Typography>
              </Stack>
            </CardContent>
            {data.video ? (
              <Box>
                <video width="100%" height="auto" controls poster={data.bg}>
                  <source src={data.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </Box>
            ) : (
              <CardMedia component="img" height="240" image={data.bg} alt="" />
            )}
            <CardContent>
              <Typography dangerouslySetInnerHTML={{ __html: data.content }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={3}>
          <Paper sx={{ width: "100%" }}>
            <List dense>
              <ListItem disablePadding>
                <ListItemButton component={RouterLink} to={"/articles"}>
                  <ListItemText>{_t("Articles list")}</ListItemText>
                </ListItemButton>
              </ListItem>
              <Divider />
              {articlesList.map((el, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton component={RouterLink} to={`/articles/${el.url}`}>
                    <ListItemText>{el.title}</ListItemText>
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default ArticleView;
